import { render, staticRenderFns } from "./OrgChooserItem.vue?vue&type=template&id=1c1662c2&"
import script from "./OrgChooserItem.vue?vue&type=script&lang=js&"
export * from "./OrgChooserItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "OrgChooserItem.vue"
export default component.exports